
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardImg,
} from 'reactstrap';
import AuthHeader from "components/Headers/AuthHeader.js";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
// import premiumLogo from '../assets/img/brand/Subscriber-rafiki.png';

function ServiceSelection() {
    const navigate = useNavigate();

    const handleServiceSelection = (serviceLevel) => {

        localStorage.setItem('selectedServiceLevel', serviceLevel);
        // console.log(serviceLevel)
        // // Navigate to the registration page
        navigate('/register');
    };

    return (
        <>
            <IndexNavbar />
            <AuthHeader
                title="Welcome!"
                lead="Choose a service"
            />
            <Container className="mt--8 pb-5">
                <Row className="justify-content-center">
                    <Col lg="5" md="7">
                        <Card className="bg-secondary border-0 mb-0">
                            <CardImg alt="Premium Service" />
                            <CardBody className="px-lg-5">
                                <div className="text-center">
                                    <Button
                                        className="my-4"
                                        color="info"
                                        onClick={() => handleServiceSelection(2)}
                                    >
                                        flexProd
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ServiceSelection;